module.exports = __webpack_public_path__ + "img/loterie-romande.629af19a.svg";